import { WindowWidthContext } from '@minecraft.utils';
import { buildOptionalProps } from './types';

export const useDropdown = (props) => {
  const { block, mobileBlock, qaId, testId, 'data-testid': dataTestId, className } = props;

  const isMobile = WindowWidthContext.useIsMobile();

  const buildBlockWidthStyle = () => (block || (mobileBlock && isMobile) ? { width: '100%' } : {});

  const buildTestIdProps = (testIdBase, element) =>
    buildOptionalProps({
      testId: `${testIdBase}-${element}`,
    });

  const buildQaIdProps = (qaIdBase, element) => buildOptionalProps({ qaId: `${qaIdBase}-${element}` });

  const ddBlockWidth = buildBlockWidthStyle();
  const qaIdBase = qaId || 'dropdown';
  const testIdBase = dataTestId || testId || 'dropdown';

  return {
    ddBlockWidth,
    buildTestIdProps,
    buildQaIdProps,
    qaIdBase,
    testIdBase,
    className,
  };
};
